export function parseZoomLink(link) {
  try {
    const url = new URL(link);
    const password = url.searchParams.get("pwd");
    return { password };
  } catch {
    return { password: "" };
  }
}
